import railCards from './railCards.js';
import hotelSuppliers from './hotelSuppliers.js';
import railStations from './railStations.js';
import airports from './airports.js';
import pointsOfInterest from './pointsOfInterest.js';
import hotels from './hotels.js';
import carSuppliersLocations from './carSuppliersLocations.js';
import carSuppliers from './carSuppliers.js';
import vehicles from './vehicles.js';
import railSuppliers from './railSuppliers.js';
import airlineCarriers from './airlineCarriers.js';
import creditCards from './creditCards.js';
import settingsResource from './settingsResource.js';
import debtors from './debtors.js';
import ctmDebtors from './ctmDebtors.js';
import features from './features.js';
import products from './products.js';
import hotelReviews from './hotelReviews.js';

export default Object.assign({}, railCards, hotelSuppliers, railStations, airports, pointsOfInterest, hotels, vehicles, carSuppliersLocations, carSuppliers, railSuppliers, airlineCarriers, creditCards, settingsResource, debtors, ctmDebtors, features, products, hotelReviews);



// WEBPACK FOOTER //
// ./src/config/fields/index.js